import script from "./inventory.vue?vue&type=script&setup=true&lang=js"
export * from "./inventory.vue?vue&type=script&setup=true&lang=js"

import "./inventory.vue?vue&type=style&index=0&id=9d0e1c9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d0e1c9a"]])

export default __exports__